import { useState, useCallback } from "react";
import { LogicChain } from "../types/logicChain";
import apiClient from "../api/client";

export function useLogicChain() {
  const [chain, setChain] = useState<LogicChain | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchChainByMessage = useCallback(async (messageId: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get<LogicChain>(`/logic-chain/${messageId}`);
      const data = response.data as unknown as LogicChain;
      setChain(data);
      return data;
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "加载逻辑链失败";
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchChainBySession = useCallback(async (sessionId: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get<LogicChain[]>(`/logic-chain/session/${sessionId}`);
      return response.data as unknown as LogicChain[];
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "加载会话逻辑链失败";
      setError(msg);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    chain,
    loading,
    error,
    fetchChainByMessage,
    fetchChainBySession,
  };
}
